// AUTOGENERATED
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer from "../Restaumatic.Restaurants.Types.CrossSellingConsumer/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq1 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer.eqCrossSellingConsumer)(Data$dEq.eqUnit).eq)();
const enabledIsSymbol = {reflectSymbol: () => "enabled"};
const visibleInIsSymbol = {reflectSymbol: () => "visibleIn"};
const CrossSellingSettingsIsSymbol = {reflectSymbol: () => "CrossSellingSettings"};
const CrossSellingSettings = x => x;
const toFillFormTypeCrossSellin = {fillFormDataType: v => "unknown"};
const newtypeCrossSellingSettin = {Coercible0: () => {}};
const hasFieldCrossSellingSetti = dictHasField => dictHasField;
const eqCrossSellingSettings = {eq: x => y => x.enabled === y.enabled && eq1(x.visibleIn)(y.visibleIn)};
const genericCrossSellingSettings = {to: x => x, from: x => x};
const showCrossSellingSettings = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer.showCrossSellingConsumer);
      return {genericShowArgs: v => [v.enabled ? "{ enabled: true, visibleIn: " + $0.show(v.visibleIn) + " }" : "{ enabled: false, visibleIn: " + $0.show(v.visibleIn) + " }"]};
    })())(CrossSellingSettingsIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCrossSellingSettings = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(enabledIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(visibleInIsSymbol)(Unscramble.decodeSet(Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer.unscrambleDecodeCrossSellingConsumer)(Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer.ordCrossSellingConsumer))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeCrossSellingSettings = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCrossSellingSettings)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CrossSellingSettingsIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(visibleInIsSymbol)((() => {
      const encode1 = Data$dSet$dSerialized.encodeSet(Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer.encodeCrossSellingConsumer).encode;
      return {encodeWithOptions: v => encode1};
    })()))(enabledIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeCrossSellingSettings = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCrossSellingSettings)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CrossSellingSettingsIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(visibleInIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dSet$dSerialized.decodeSet(Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer.ordCrossSellingConsumer)(Restaumatic$dRestaurants$dTypes$dCrossSellingConsumer.decodeCrossSellingConsumer).decode;
    return {decodeWithOptions: v => decode2};
  })())())(enabledIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  CrossSellingSettings,
  CrossSellingSettingsIsSymbol,
  decodeCrossSellingSettings,
  enabledIsSymbol,
  encodeCrossSellingSettings,
  eq1,
  eqCrossSellingSettings,
  genericCrossSellingSettings,
  hasFieldCrossSellingSetti,
  newtypeCrossSellingSettin,
  showCrossSellingSettings,
  toFillFormTypeCrossSellin,
  unscrambleDecodeCrossSellingSettings,
  visibleInIsSymbol
};
